import { styled } from '@linaria/react';
import { colors, layout } from '../../theme/tokens';

const SIDE_NAV_WIDTH = '72px';

export const Shell = styled.div`
  display: flex;
  min-height: 100vh;
  background: ${colors.white};
`;

export const ContentArea = styled.div`
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  min-height: 100vh;

  padding-bottom: 64px;

  @media (min-width: ${layout.desktopBreakpoint}) {
    margin-left: ${SIDE_NAV_WIDTH};
    padding-bottom: 0;
  }
`;

export const Main = styled.main`
  flex: 1;
  min-width: 0;
  overflow-x: clip;
`;
